"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = parseFilename;

var _toArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toArray"));

function parseFilename(filename) {
  if (!filename) {
    return {
      extname: '',
      name: ''
    };
  } else if (~filename.indexOf('.')) {
    var _filename$split$rever = filename.split('.').reverse(),
        _filename$split$rever2 = (0, _toArray2["default"])(_filename$split$rever),
        extensionWithoutDot = _filename$split$rever2[0],
        nameSegments = _filename$split$rever2.slice(1);

    return {
      extname: '.' + extensionWithoutDot,
      name: nameSegments.reverse().join('.')
    };
  } else {
    return {
      extname: '',
      name: filename
    };
  }
}